export const environment = {
  production: false,
  name: 'base',
  api: {
    url: 'http://localhost:8080',
  },
  // Legacy key for backward compatibility
  google_places_key: 'AIzaSyAxZmtTWIj_QpEU0oeQSvVyAzybif9tgpM',
  // Platform-specific Google Places API keys
  android_google_places_key: 'AIzaSyCqrAm1Qy7sSn9lWxXOz7fwOgMypuALcaw',
  browser_google_places_key: 'AIzaSyAxZmtTWIj_QpEU0oeQSvVyAzybif9tgpM',
  ios_google_places_key: 'AIzaSyADpSsRcEgeTxUKxL-EgHr0b29_kP6huEg',
  dev_google_places_key: 'AIzaSyDrR-XfHigHfrV2x-kgQiIQMU6nZZcFEac', // For localhost development
  // Google Analytics Tracking ID (set to null to disable, or use different IDs per environment)
  googleAnalyticsId: null, // Set your GA4 Measurement ID here (e.g., 'G-XXXXXXXXXX')
};

import 'zone.js/plugins/zone-error';
